import Joi from "joi";

export interface CreateCheckListModelTaskDTO {
  title: string;
  description?: string | null;
  order: number;
  checkListModelId? : number ;
}

export const CreateCheckListModelTaskDTOSchema = Joi.object({
    title: Joi.string()
      .required()
      .messages({
        "string.base": "O título deve ser um texto",
        "any.required": "O título é obrigatório",
        "string.empty": "O título não pode ser vazio",
      }),
    description: Joi.string()
      .allow(null, "")
      .max(250)
      .messages({
        "string.base": "A descrição deve ser um texto",
        "string.max": "A descrição não pode ter mais de 250 caracteres",
      }),
    order: Joi.number()
      .required()
      .greater(0)
      .messages({
        "number.base": "A ordem deve ser um número",
        "any.required": "A ordem é obrigatória",
        "number.greater": "A ordem deve ser maior que 0",
      }),
      checkListModelId: Joi.number()
      .greater(0)
      .messages({
        "number.base": "O ID do modelo de checklist deve ser um número",
        "any.required": "O ID do modelo de checklist é obrigatório",
        "number.greater": "O ID do modelo de checklist deve ser maior que 0",
      }),
  });